import { Color, DefaultValue, getDefaultTransition, Spacing, transientOptions } from '@billy/design-system'
import styled from '@emotion/styled'

interface RowProps {
  $depth: number
  $isDragOver?: boolean
  $isSelected?: boolean
}

export const IconPlaceholder = styled.span`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
`

export const Row = styled('div', transientOptions)<RowProps>`
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 ${Spacing.S8};
  padding-left: calc(${Spacing.S4} + ${({ $depth }) => $depth} * ${Spacing.S16});
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ $isSelected }) => ($isSelected ? Color.Grey100 : 'inherit')};
  color: ${Color.Grey950};
  cursor: pointer;
  ${getDefaultTransition('background-color')}

  &:hover {
    background-color: ${Color.Grey100};
  }

  ${({ $isDragOver }) =>
    $isDragOver &&
    `
      border: 2px dashed ${Color.Grey300};
      background-color: ${Color.Grey100};
    `}
`
